import { MAINTENANCE_INTELLIGENCE_ROUTING } from "./maintenance-intelligence-routing";
import { RouteParameters } from "./route-parameters";
import { SQUAWKS_ROUTING } from "./squawks-routing";

const MAINTENANCE_ROUTING = {
  MAINTENANCE_INTELLIGENCE: MAINTENANCE_INTELLIGENCE_ROUTING,
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance`,
  SQUAWKS: SQUAWKS_ROUTING,
} as const;

export { MAINTENANCE_ROUTING };
